export const isCurrentRobotImageExpanded = (expandedImageUrls, robotUrl) =>
  expandedImageUrls.map((expandedImageUrl) => expandedImageUrl.url)?.includes(robotUrl);
